import { data } from "autoprefixer";
import { graphql, Link } from "gatsby";
import React, { useEffect, useRef } from "react";

import { CONTENT_TYPE } from "../../../company/entities";
import ColumnArea from "../modules/ColumnArea/ColumnArea";
import { TypeForm } from "../modules/Forms/domain/Forms";
import { Info } from "../modules/Forms/Views/Info/Info";
import withForm from "../modules/Forms/withForm";
import LanguageControl from "../modules/LanguageControl/LanguageControl";
import Layout from "../modules/Layout/Layout";
import { useModal } from "../modules/Modals/useModal";
import { withModal } from "../modules/Modals/withModal";
import NewCard from "../modules/NewCard/NewCard";
import Placeholder from "../modules/Placeholder/Placeholder";
import { getSlugWithLang } from "../modules/shared/utils/getSlugWithLang";
import { useAudioPlayer } from "../modules/SoundControl/AudioPlayerContext";
import { IPageProps } from "../types/thecookies";
import {SEO} from "../modules/SEO/SEO";

const EntityTemplate = (props: IPageProps<Queries.EntityPageQuery>) => {
  const { carlos, edificio, fundacion, espacioUno, espacioDos, info } = props.data;
  const tableRef = useRef() as React.MutableRefObject<HTMLDivElement>;
  const column3 = useRef() as React.MutableRefObject<HTMLDivElement>;
  const column4 = useRef() as React.MutableRefObject<HTMLDivElement>;
  const column5 = useRef() as React.MutableRefObject<HTMLDivElement>;

  function getOffsetBottomContentColumn(htmlElement: HTMLElement): number {
    return htmlElement.offsetTop + htmlElement.offsetHeight;
  }
  if (props.data.content?.contentType === CONTENT_TYPE.AUDIO) {
    const { setAudio } = useAudioPlayer();
    setAudio(props.data.content?.audio);
  }
  console.log(props.pageContext)
  function setPositionAndSizePlaceholder() {
    if (window) {
      const thirdColumnStart = column3.current.offsetLeft;
      const listColumn3 = column3.current?.children[1] as unknown as HTMLElement;
      const listColumn4 = column4.current?.children[1] as unknown as HTMLElement;
      const listColumn5 = column5.current?.children[1] as unknown as HTMLElement;

      const contentsHeights = [listColumn3, listColumn4, listColumn5].map(getOffsetBottomContentColumn);
      const maxContentHeight = Math.max(...contentsHeights);

      const offsetBottomColumn = column3.current?.offsetTop + column3.current?.offsetHeight;
      const lastColumnFinish = column5.current.offsetLeft + column5.current.offsetWidth;
      const widthPlaceHolder = lastColumnFinish - thirdColumnStart;
      document.body.style.setProperty("--width-placeholder", `${widthPlaceHolder}px`);
      document.body.style.setProperty("--position-offset-bottom-content-heighten", `${maxContentHeight}px`);
      document.body.style.setProperty("--offset-bottom-column", `${offsetBottomColumn}px`);
    }
  }
  const LineSvg = () => (
    <img
      src="data:image/svg+xml,%3Csvg width='91' height='2' viewBox='0 0 91 4' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cline x1='0.5' y1='2' x2='90.5' y2='2' stroke='%23FF3829' stroke-width='3'/%3E%3C/svg%3E"
      alt="Guion SVG"
    />
  );
  const [has_modalForm, toggleModalForm] = useModal();
  const InfoFormUse = withForm(Info, TypeForm.INFO);
  const InfoFormUseWithModal = withModal(
    InfoFormUse,
    {},
    { has_modal: has_modalForm, toggleModal: toggleModalForm },
    <div className={"modal-title"}>
      <p>Contacto</p>
      {<LineSvg />}
      <p> Formulario</p>
    </div>,
  );

  useEffect(() => {
    setPositionAndSizePlaceholder();
    window.addEventListener("resize", setPositionAndSizePlaceholder);
    return () => {
      window.removeEventListener("resize", setPositionAndSizePlaceholder);
    };
  }, []);

  const contentBlog = {
    isBlog: props.pageContext.id === CONTENT_TYPE.BLOG,
    contentType: CONTENT_TYPE.BLOG,
    list: [...props.data.allPostPinned.nodes, ...props.data?.allSanityPost.nodes],
  };
  return (
    <Layout
      legalLinks={props.data.legals.nodes.map((node) => {
        return {
          slug: getSlugWithLang(`/legal/${node.slug}`, null),
          name: node.name,
        };
      })}
    >
      <InfoFormUseWithModal />
      <ColumnArea settings={{ area: "column-1" }} data={edificio}>
        <ColumnArea settings={{ isNested: true }} data={info} />
        <ul className={"column__list column__list--nested"}>
          <li>
            <Link className={"column__item"} to={`/noticias/`}>
              Noticias
            </Link>
          </li>
          <li>
            <button className={"column__item button-clean"} onClick={toggleModalForm}>
              Contacto
            </button>
          </li>
        </ul>
      </ColumnArea>
      <ColumnArea settings={{ area: "column-2" }} data={carlos} />
      <ColumnArea ref={column3} settings={{ area: "column-3" }} data={fundacion} />
      <ColumnArea ref={column4} settings={{ area: "column-4" }} data={espacioUno} />
      <ColumnArea ref={column5} settings={{ area: "column-5" }} data={espacioDos} />
      <Placeholder
        data={props.data?.content || props.data.sanityPost || (contentBlog.isBlog && contentBlog)}
        settings={{
          isModal: (props.data?.content || props.data.sanityPost || (contentBlog.isBlog && contentBlog)) ? true : false,
          breadcrumbs: props.pageContext.breadcrumbs,
          nestedContent: props.data.contentNestedList?.contentNested,
        }}
      >
        {/* Si no recibe contenido carga las ultimas noticias, deberia pasar solo en la home */}
        {!props.data.content && props.data.highlightedContent && (
          <div className={`placeholder__post-list --cover`}>
            {props.data.highlightedContent.highlights.map((node: Queries.SanityPost, index) => (
              <NewCard data={{ ...node }} key={index} />
            ))}
          </div>
        )}
      </Placeholder>
      <div className={`footer-left`}>
      </div>
      <div className={`footer-right`}>
        <LanguageControl/>
      </div>
    </Layout>
  );
};

export default EntityTemplate;

export const Head = ({ data, pageContext, location }: IPageProps<Queries.EntityPageQuery>) => (
  <SEO
    metas={{
      seo: {
        title:  pageContext.breadcrumbs[pageContext.breadcrumbs.length - 1]?.name || ' Centro De Arte Edificio Del Mirador | CAEMZ',
        description: `${location.pathname == "/" ? "El Centro de Arte Edificio del Mirador en Zaragoza te invita a explorar su variada programación cultural. Descubre nuestra exposición Obra Gráfica del Estatuto de Aragón y Hallazgos Romanos." : ""}`,
      },
      slug: pageContext.breadcrumbs[pageContext.breadcrumbs.length - 1]?.slug || "/",
      language: pageContext.language,
      hrefLangList: data.legals.nodes,
    }}
  />
);

export const query = graphql`
  query EntityPage($id: String, $idRow: String! = "", $language: String = "es_es") {
    content: sanityContent(id: { eq: $id }) {
      contentType
      text
      audio {
        name
        file {
          public_id
          secure_url
        }
      }
      assets {
        __typename
        ... on SanityAsset {
          name
          file {
            public_id
            secure_url
            format
            image {
              gatsbyImageData(width: 1280, placeholder: BLURRED)
              public_id
            }
          }
          footLine
        }
        ... on SanityAssetFile {
          name
          file {
            asset {
              url
            }
          }
        }
      }
      redirect
    }
    contentNestedList: sanitySingleRow(id: { eq: $idRow }) {
      contentNested {
        slug
        name
      }
    }
    allPostPinned: allSanityPost(sort: {publishedAt: DESC}, filter: {isPinned: {eq: true}}) {
      nodes {
        name
        slug
        isPinned
        id
      }
    }
    allSanityPost(sort: {publishedAt: DESC}, filter: {isPinned: {ne: true}}) {
      nodes {
        name
        isPinned
        slug
        id
      }
    }
    sanityPost(id: { eq: $id }) {
      name
      text
      contentType
      pdfFile {
        asset {
          url
        }
      }
    }

    highlightedContent: sanityShared(language: { eq: $language }) {
      highlights {
        asset {
          name
          file {
            public_id
          }
          image {
            gatsbyImageData(width: 1280, placeholder: BLURRED)
            public_id
          }
        }
        link {
          ... on SanityColumn {
            slug
          }
          ... on SanityPost {
            slug
          }
        }
      }
    }

    carlos: sanityColumn(language: { eq: $language }, ref: { eq: "carlos-moros" }) {
      ...column
    }
    edificio: sanityColumn(language: { eq: $language }, ref: { eq: "edificio-mirador" }) {
      ...column
    }
    fundacion: sanityColumn(language: { eq: $language }, ref: { eq: "fundacion" }) {
      ...column
    }
    info: sanityColumn(language: { eq: $language }, ref: { eq: "info" }) {
      ...column
    }
    espacioUno: sanityColumn(language: { eq: $language }, ref: { eq: "espacio-1" }) {
      ...column
    }
    espacioDos: sanityColumn(language: { eq: $language }, ref: { eq: "espacio-2" }) {
      ...column
    }
    legals: allSanityLegal(filter: { language: { eq: $language } }) {
      nodes {
        name
        slug
      }
    }
  }
`;
